document.addEventListener("DOMContentLoaded", () => {

  // --- Inject modal HTML into the page ---
  const modalHTML = `
    <div id="youtube-lightbox" class="yt-lightbox">
      <div class="yt-lightbox-content">
        <span class="yt-close">&times;</span>
        <iframe src="" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>

      </div>
    </div>
  `;
  document.body.insertAdjacentHTML("beforeend", modalHTML);


  // --- Inject CSS automatically ---
  const style = document.createElement('style');
  style.textContent = `
  .yt-lightbox {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.85);
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    padding: 20px;
  }

  .yt-lightbox.open {
    display: flex;
  }

  .yt-lightbox-content {
    position: relative;
    width: 80vw; /* 80% of viewport width */
    max-width: 1600px;
  }

  .yt-lightbox-content iframe {
    width: 100%;
    height: calc(80vw * 0.56);
    max-height: 70vh;
    border: none;
    background: transparent;
  }

  /* Exit button styling */
  .yt-close {
    position: absolute;
    top: -50px;    /* Moved above the video */
    right: 0;
    width: 38px;
    height: 38px;
    background: rgba(255,255,255,0.12);
    border-radius: 50%;
    color: white;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    transition: all 0.25s ease;
  }

  .yt-close:hover {
    background: #F7F4F0;
    color: black;
    box-shadow: 0 0 12px #F7F4F0;
  }
`;

  document.head.appendChild(style);


  // Detect all links on page
  const allLinks = document.querySelectorAll("a[href]");
  allLinks.forEach(link => {
    link.addEventListener("click", e => {
      const url = link.href;

      if (isYoutubeUrl(url)) {
        e.preventDefault();
        openYoutubeLightbox(url);
      }
    });
  });


  // Close modal
  document.addEventListener("click", e => {
    if (e.target.classList.contains("yt-close") || e.target.id === "youtube-lightbox") {
      closeYoutubeLightbox();
    }
  });


  // ESC key closes modal
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") closeYoutubeLightbox();
  });
});


// ---- Helpers ----

function isYoutubeUrl(url) {
  return url.includes("youtube.com/watch") || url.includes("youtu.be/");
}

function openYoutubeLightbox(url) {
  const modal = document.getElementById("youtube-lightbox");
  const iframe = modal.querySelector("iframe");
  iframe.src = convertToEmbed(url);
  modal.classList.add("open");
}

function closeYoutubeLightbox() {
  const modal = document.getElementById("youtube-lightbox");
  const iframe = modal.querySelector("iframe");
  iframe.src = "";
  modal.classList.remove("open");
}

function convertToEmbed(url) {
  let id = "";
  if (url.includes("youtu.be/")) {
    id = url.split("youtu.be/")[1];
  } else if (url.includes("youtube.com/watch")) {
    id = new URL(url).searchParams.get("v");
  }
  return `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1`;
}
